module.exports = __webpack_public_path__ + "img/flag-CR.144b040b.png";